
import { useDispatch, useSelector } from 'react-redux'
import PageTopTitle from '../../components/shared/PageTopTitle'
import styled from 'styled-components'
import { useEffect, useState } from 'react'
import TopMenus from '../../components/shared/TopMenus'
import SendNotificationAll from '../../components/bildirim/SendNotificationAll'
import SendNotificationSpecific from '../../components/bildirim/SendNotificationSpecific'
import SendNotificationAllPortalUsers from '../../components/portalBildirim/SendNotificationAllPortalUsers'
import SendNotificationSpecificPortalUser from '../../components/portalBildirim/SendNotificationSpecificPortalUser'
import PortalNotificationHistory from '../../components/portalBildirim/PortalNotificationHistory'
import { clearNotificationPortalForm, setNotificationActiveTabPortal } from '../../features/admin4/admin4Slice'

const Container = styled.div`
    width: 100%;

.wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

    .content{
      padding: 40px;
      width: auto;
      min-width: 780px;

      .sender-content{
        display: flex;
        flex-direction: column;
        align-items: center;


        .title{
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
          margin: 40px 0;
          padding: 10px 30px;
          border-radius: 10px;
          background-color: ${({theme}) => theme.secondaryBgColor};
          border: 1px solid ${({theme}) => theme.mainBorderColor};
        }

        .content-container{
          width: 100%;
        }
      }
    }

    
}
`

const menuList = [
  {
      id: 1,
      text: "Herkese Bildirim Gönder"
  },
  {
      id: 2,
      text: "Firmaya Göre Bildirim Gönder"
  },
]


const PortalBildirimGonder = () => {


  const {

    notificationActiveTabPortal,
      notificationActiveTab
} = useSelector(state => state.admin4)

const dispatch = useDispatch()

  return (
    <Container>


    <div className="wrapper">
      <PageTopTitle title={"Portal Bildirim Gönder"} position='sticky'/>


        <div className="content">
          <TopMenus activeMenuId={notificationActiveTabPortal} setActiveMenuId={(data)=> {dispatch(setNotificationActiveTabPortal(data)); dispatch(clearNotificationPortalForm())}} menuList={menuList} containerWidth='100%'/>

            
          <div className="sender-content">
            <h2 className="title">{notificationActiveTab === 1 ? "Herkese Bildirim Gönder" : "Telefon Numarasına Göre Bildirim Gönder"}</h2>
            <div className="content-container">

            {
              notificationActiveTabPortal === 1 &&
              <SendNotificationAllPortalUsers/>
            }
            
            {
              notificationActiveTabPortal === 2 &&
              <SendNotificationSpecificPortalUser/>
            }
              
            </div>
          </div>
        </div>
        {/* <ScheduledNotificationList/> */}

        <PortalNotificationHistory/>


    </div>
    </Container>
  )
}

export default PortalBildirimGonder